<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="EPI">… it started like a <span class="italic-1">guilty thing</span></p>
<p class="EPI">Upon a fearful summons.</p>
<p class="EPISS">Shakespeare, <span class="ePub-I">Hamlet</span>, Act 1, Scene 1</p>
<p class="EPI">Blank misgivings of a Creature</p>
<p class="EPI">Moving about in worlds not realised,</p>
<p class="EPI">High instincts before which our mortal Nature</p>
<p class="EPI">Did tremble like a guilty thing surprised …</p>
<p class="EPISS">Wordsworth, ‘Intimations of Immortality’</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7295fbae